import axios from 'axios';
import is from './is';

const getHost = () => (is().dev ? 'siteplus.wtf' : window.location.host);

const REGISTRATION_HOST = `https://rest.${getHost()}/member-api-service/platform/`;
const HELP_HOST = `https://rest.${getHost()}/help-center-api/1.0`;
export const { CancelToken } = axios;

export const request = axios.create({
  baseURL: REGISTRATION_HOST,
  timeout: 60000,
  __retryRequestQuantity: 0,
});

export const helpRequest = axios.create({
  baseURL: HELP_HOST,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});
